module.exports = __webpack_public_path__ + "img/4_36.1bfb943e.png";